const SURVEY_ACTION_TYPE = {
  GET_SURVEYS: 'GET_SURVEYS',
  GET_SURVEY: 'GET_SURVEY'
}
export default SURVEY_ACTION_TYPE
